module.exports = __webpack_public_path__ + "static/media/cyroth_nano_circles_mobile.aae23bd0.png";